import { render, staticRenderFns } from "./ViewCustomer.vue?vue&type=template&id=bdd92928"
import script from "./ViewCustomer.vue?vue&type=script&lang=js"
export * from "./ViewCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports